((ProductTileOptions, $) => {
  "use strict";

  const $dom = {};

  const cacheDom = () => {
    $dom.productGridItem = $('[data-product-grid-item]');
    $dom.optionSwatch = $('[data-swatch]');
  };

  const appendVariantToLink = (url, variantId) => {
    if(url.includes('?variant=')) {
      url = url.substring(0, url.indexOf('?variant=')); // strip param
    }

    return `${url}?variant=${variantId}`;
  }

  const updateSwatch = ($swatch) => {
    const imageSource = $swatch.attr('data-image-src');
    const salePrice = $swatch.attr('data-price');
    const comparePrice = $swatch.attr('data-compare-price');
    const $scopedCard = $swatch.closest($dom.productGridItem);
    const $scopedImageWrapper = $scopedCard.find('[data-variant-image-item]');
    const $scopedImage = $scopedImageWrapper.find('img');
    const $scopedAnchors = $scopedCard.find('a[href]');
    const $scopedPriceWrapper = $scopedCard.find('[data-product-price]');
    const $scopedPriceRange = $scopedPriceWrapper.find('[data-product-price-range]');
    const $scopedPriceSale = $scopedPriceWrapper.find('[data-product-price-sale]');
    const $scopedPriceCompare = $scopedPriceWrapper.find('[data-product-price-compare]');
    const productUrl = $scopedCard.find('a').attr('href');

    // set active swatch
    $scopedCard.find('.swatch').removeClass('active');
    $swatch.closest('.swatch').addClass('active');

    // set active image
    $scopedImage.attr(`src`, imageSource);
    $scopedImage.attr(`srcset`, imageSource);
    const $scopedPicture = $scopedImage.closest(`picture`);
    if ($scopedPicture.length > 0) {
      $scopedPicture.find(`source`).each((idx, source) => {
        $(source).attr(`srcset`, imageSource);
      });
    }

    // set anchors to corresponding variant
    const variantId = $swatch.attr('data-color-variant');
    $scopedAnchors.attr('href', appendVariantToLink(productUrl, variantId));

    // set price to corresponding variant
    if (comparePrice && Number.parseInt(comparePrice, 10) > Number.parseInt(salePrice, 10)) {
      $scopedPriceCompare.html(theme.Currency.formatMoney(comparePrice, StyleHatch.currencyFormat).replace(`.00`, ``));
    } else {
      $scopedPriceCompare.empty();
    }
    $scopedPriceSale.html(theme.Currency.formatMoney(salePrice, StyleHatch.currencyFormat).replace(`.00`, ``));
  };

  const bindUIActions = () => {  
    const swatchAction = (event) => {
      const $swatch = $(event.currentTarget);
      const $tile = $swatch.closest(`[data-product-grid-item]`);
      $tile.addClass(`product-grid-item--hover`);
      updateSwatch($swatch);

    };
    const mouseLeaveAction = (event) => {
      const $swatch = $(event.currentTarget);
      const $tile = $swatch.closest(`[data-product-grid-item]`);
      $tile.removeClass(`product-grid-item--hover`);
    };

    $dom.optionSwatch.on('click', swatchAction);
    $dom.optionSwatch.on('mouseenter', swatchAction);
    $dom.optionSwatch.on('mouseleave', mouseLeaveAction);
  };

  const initTile = () => {
    $dom.productGridItem.each(function() {
      const $activeSwatch = $(this).find('.swatch.active input');

      if ($activeSwatch.length <= 0) {
        return;
      }

      updateSwatch($activeSwatch);
    });
  };

  const init = () => {
    cacheDom();
    initTile();
    bindUIActions();
  };

  ProductTileOptions.init = init;
})((window.ProductTileOptions = window.ProductTileOptions || {}), jQuery);
